import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Save, Trash2 } from "lucide-react";
import api, { formatErr } from "../../lib/api";

export default function DevRoles() {
  const [perms, setPerms] = useState([]);
  const [roles, setRoles] = useState([]);
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ name: "", color: "#737373", permissions: [] });

  const refresh = async () => {
    const [p, r] = await Promise.all([api.get("/developer/permissions"), api.get("/developer/roles")]);
    setPerms(p.data); setRoles(r.data);
  };
  useEffect(()=>{ refresh(); }, []);

  const togglePerm = (p) => {
    const cur = (editing? editing.permissions : form.permissions) || [];
    const next = cur.includes(p) ? cur.filter(x=>x!==p) : [...cur, p];
    if (editing) setEditing({...editing, permissions: next});
    else setForm({...form, permissions: next});
  };

  const save = async () => {
    try {
      if (editing) await api.put(`/developer/roles/${editing.id}`, { permissions: editing.permissions, name: editing.name, color: editing.color });
      else await api.post("/developer/roles", form);
      toast.success("Saved"); setEditing(null); setCreating(false); setForm({name:"",color:"#737373",permissions:[]}); refresh();
    } catch (e) { toast.error(formatErr(e)); }
  };

  const del = async (rid) => {
    if (!window.confirm("Delete role?")) return;
    try { await api.delete(`/developer/roles/${rid}`); toast.success("Deleted"); refresh(); }
    catch (e) { toast.error(formatErr(e)); }
  };

  const active = editing || (creating? form : null);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="overline mb-2">Access Control</div>
          <h1 className="font-display text-4xl text-white">Roles & Permissions</h1>
        </div>
        <button data-testid="role-new" onClick={()=>{setCreating(true); setEditing(null); setForm({name:"",color:"#737373",permissions:[]});}} className="btn-primary"><Plus size={13}/> New Role</button>
      </div>

      <div className="grid md:grid-cols-[300px_1fr] gap-6">
        <div className="space-y-2">
          {roles.map(r => (
            <button key={r.id} data-testid={`role-${r.id}`} onClick={()=>{setEditing({...r}); setCreating(false);}} className={`w-full text-left card-luxe p-4 ${editing?.id===r.id? "border-copper":""}`}>
              <div className="flex items-center gap-2"><span className="w-2 h-2 rounded-full" style={{background:r.color}}/><span className="text-white">{r.name}</span>{r.system && <span className="text-[9px] uppercase tracking-luxe text-white/30 ml-auto">System</span>}</div>
              <div className="text-xs text-white/40 mt-1">{r.permissions?.length || 0} permissions</div>
            </button>
          ))}
        </div>
        {active && (
          <div className="card-luxe p-6">
            <div className="grid grid-cols-2 gap-4 mb-5">
              <div>
                <div className="overline mb-2">Name</div>
                <input className="input-box" value={active.name} onChange={(e)=> editing? setEditing({...editing, name:e.target.value}) : setForm({...form, name:e.target.value})}/>
              </div>
              <div>
                <div className="overline mb-2">Color</div>
                <input type="color" className="input-box h-11" value={active.color} onChange={(e)=> editing? setEditing({...editing, color:e.target.value}) : setForm({...form, color:e.target.value})}/>
              </div>
            </div>
            <div className="overline mb-3">Permissions ({active.permissions?.length||0}/{perms.length})</div>
            <div className="grid md:grid-cols-2 gap-2 max-h-[480px] overflow-y-auto pr-2">
              {perms.map(p => (
                <label key={p} className="flex items-center gap-2 text-sm cursor-pointer hover:text-white text-white/60">
                  <input type="checkbox" checked={active.permissions?.includes(p)||false} onChange={()=>togglePerm(p)} disabled={editing?.id==="developer"}/>
                  <span className="font-mono text-xs">{p}</span>
                </label>
              ))}
            </div>
            <div className="flex gap-3 mt-6 pt-4 border-t border-white/5">
              <button data-testid="role-save" onClick={save} className="btn-primary"><Save size={13}/> Save</button>
              {editing && !editing.system && <button onClick={()=>del(editing.id)} className="btn-outline text-red-400 border-red-400/30"><Trash2 size={13}/> Delete</button>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
